"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
const CheckboxOff = props => /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16"
}, props), /*#__PURE__*/_react.default.createElement("path", {
  className: "fill",
  d: "M2.564 0h10.872c.892 0 1.215.093 1.54.267.327.174.583.43.757.756.174.326.267.65.267 1.54v10.873c0 .892-.093 1.215-.267 1.54-.174.327-.43.583-.756.757-.326.174-.65.267-1.54.267H2.563c-.892 0-1.215-.093-1.54-.267a1.817 1.817 0 0 1-.757-.756C.093 14.65 0 14.327 0 13.437V2.563c0-.892.093-1.215.267-1.54.174-.327.43-.583.756-.757C1.35.093 1.673 0 2.563 0zm.718 2c-.446 0-.607.046-.77.134a.909.909 0 0 0-.378.378c-.088.163-.134.324-.134.77v9.436c0 .446.046.607.134.77.087.163.215.291.378.378.163.088.324.134.77.134h9.436c.446 0 .607-.046.77-.134a.909.909 0 0 0 .378-.378c.088-.163.134-.324.134-.77V3.282c0-.446-.046-.607-.134-.77a.909.909 0 0 0-.378-.378c-.163-.088-.324-.134-.77-.134H3.282z"
}));
var _default = exports.default = CheckboxOff;